/* eslint-disable react/require-default-props */
/* eslint-disable react/prop-types */
import React, { Fragment } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import TextLine from 'app/components/ui/TextLine';
import PartnersComment from 'app/components/PartnersConmment';

import styles from './dish-description.scss';


export function DishDescription(props) {
    const {
        colors,
        isEasterBox,
        description = '',
        partnersComment = '',
        layout = 'default',
        areDetailsEnabled = false,
        pageId,
    } = props;

    const subtitleClasses = cn({
        [styles['dish-description']]: true,
        [styles['dish-description--blue']]: colors === 'blue',
        [styles['dish-description--pink']]: colors === 'pink',
        [styles[`dish-description--${layout}`]]: true,
        'description--lp': true,
        [pageId]: true,
    });

    const detailsClasses = cn({
        [styles['get-details']]: areDetailsEnabled,
        'description--lp': true,
    });

    return (
        <>
            {description && (
                <p className={subtitleClasses}>
                    {Array.isArray(description) && (
                        <>
                            {description.map((line) => (
                                <Fragment key={line}>
                                    <TextLine>
                                        {line}
                                    </TextLine>
                                    <br />
                                </Fragment>
                            ))}
                        </>
                    )}
                    {!isEasterBox && description instanceof String ? (
                        <TextLine>{description}</TextLine>
                    ) : description}
                    {' '}
                    {areDetailsEnabled && (
                        <span
                            className={detailsClasses}
                            role="none"
                            onClick={(e) => {
                                if (!isEasterBox) return;
                                window.location = '/easterbox';
                                e.stopPropagation();
                            }}
                        >
                            Подробнее
                        </span>
                    )}
                </p>
            )}
            {!description && partnersComment && (
                <p className={subtitleClasses}>
                    <PartnersComment comment={partnersComment} />
                    {' '}
                </p>
            )}
        </>
    );
}

DishDescription.propTypes = {
    areDetailsEnabled: PropTypes.bool,
    description: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.string),
        PropTypes.string,
        PropTypes.node,
    ]),
    partnersComment: PropTypes.string,
    layout: PropTypes.oneOf(['default', 'secondary']),
};
